"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTypeEnum = void 0;
var QuestionTypeEnum;
(function (QuestionTypeEnum) {
    QuestionTypeEnum[QuestionTypeEnum["TEXT"] = 0] = "TEXT";
    QuestionTypeEnum[QuestionTypeEnum["NUMBER"] = 1] = "NUMBER";
    QuestionTypeEnum[QuestionTypeEnum["RADIO"] = 2] = "RADIO";
})(QuestionTypeEnum || (exports.QuestionTypeEnum = QuestionTypeEnum = {}));
